;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import * as Sentry from "@sentry/nextjs"
import { CombinedGraphQLErrors } from "@apollo/client/errors"

const reportedErrors = new WeakSet<object>()

function alreadyReported(error: unknown) {
  if (!error || typeof error !== "object") return false
  const sources = CombinedGraphQLErrors.is(error)
    ? [error, ...error.errors]
    : [error]
  const reported = sources.some((source) => reportedErrors.has(source))
  sources.forEach((source) => reportedErrors.add(source))
  return reported
}

export function reportOperationError(
  error: unknown,
  tags: Record<string, string | number | boolean>,
) {
  if (alreadyReported(error)) return
  Sentry.captureException(error, { tags })
}

export function handleQueryError(error, context = null) {
  if (error) {
    if (error.name === "AbortError" || alreadyReported(error)) return
    // Add additional context if provided
    if (context) {
      Sentry.captureException(error, {
        extra: {
          errorContext: context,
        },
        tags: {
          error_type: "prismic_query_error",
        },
      })
    } else {
      Sentry.captureException(error)
    }
    // Optionally, you can add more logic here, such as logging to console or showing a notification
  }
}
